const button = () => {
  const buttons = document.querySelectorAll('.v-button');
  if (!buttons.length) return;

  function buttonAlert() {
    alert('HEY');
  }
  [...buttons].forEach(btn => btn.addEventListener('click', buttonAlert));
}

export default button;